import { SalaryCertificateTypeCodes } from "@Enum/api/SalaryCertTypeCodes.enum";

export const salaryTypeOptionsAllowed: Record<number, boolean> = {
  [SalaryCertificateTypeCodes.TRAFIC_LICENSE]: true,
  [SalaryCertificateTypeCodes.EMBASSY]: true,
  [SalaryCertificateTypeCodes.IMMIGRATION]: true,
  [SalaryCertificateTypeCodes.CREDIT_CARD]: true,
  [SalaryCertificateTypeCodes.LOANS]: true,
  [SalaryCertificateTypeCodes.BANK]: true,
  [SalaryCertificateTypeCodes.OTHER]: true,
};
